// Search + sort for the Save collection pages (Pins, Community). Both run in genesis, not in the
// browser: the lists page in 30s, so a browser-side sort or search only ever saw the pages loaded
// so far (spark#1008). "Recently added" is intentionally omitted: the pin queries don't return a
// pin timestamp, so name A–Z / Z–A is the reliable, shared sort.

import { SortOrder, StringFilterCaseSensitivity, type StringFilterInput } from "@/graphql/generated/operations";

export type SortDir = "az" | "za";

export const SORT_OPTIONS: readonly { value: SortDir; labelId: string }[] = [
  { value: "az", labelId: "sort.nameAz" },
  { value: "za", labelId: "sort.nameZa" },
];

export function sortOrderOf(sort: SortDir): SortOrder {
  return sort === "az" ? SortOrder.Asc : SortOrder.Desc;
}

/** The typed search term as a name filter; null for a blank term, which filters nothing. */
export function nameContains(term: string): StringFilterInput | null {
  const trimmed = term.trim();
  return trimmed ? { contains: trimmed, caseSensitivity: StringFilterCaseSensitivity.CaseInsensitive } : null;
}

/**
 * Combines filter clauses for genesis. Its filter specs apply only ONE top-level field (early
 * return in *FilterSpec), so two conditions side by side silently lose one; `and` INNER JOINs them.
 */
export function allOf<W extends { and?: W[] | null }>(...clauses: (W | null)[]): W {
  const present = clauses.filter((clause): clause is W => clause !== null);
  return present.length === 1 ? present[0]! : ({ and: present } as W);
}
